import { assignedResource } from '@townsquare/assigned/resource';
import { calendarConnectorsResource } from '@townsquare/calendar-connectors-resource';
import { WAC_CROSSFLOW_PARAMS } from '@townsquare/crossflow/wac';
import { homeHeaderViewResource } from '@townsquare/home-header/resources';
import Loadable from '@townsquare/loadable';
import { onboardingResource } from '@townsquare/onboarding/resource';
import { homeRecentsResource } from '@townsquare/recents-feed/resource';
import { GlobalHomePageRoute } from '@townsquare/router/route-types';
import { homeTabRoute as homeTabRouteDefinition } from '@townsquare/routes/hometab-view';
import { rovoActivationResource } from '@townsquare/rovo/activation';
import { platformStarredFeedResource } from '@townsquare/starred-feed/resource';
import { titanEapCrossFlowQueryResource } from '@townsquare/titan-eap-cross-flow/resource';
import { frequentContainersResource } from '@townsquare/where-you-work/resource';

homeTabRouteDefinition.component = Loadable({
	loader: () => import(/* webpackChunkName: "hometab-view" */ './components/HomeTabView'),
	loading: () => null,
});
homeTabRouteDefinition.resources = [
	titanEapCrossFlowQueryResource,
	homeHeaderViewResource,
	onboardingResource,
	frequentContainersResource,
	assignedResource,
	platformStarredFeedResource,
	homeRecentsResource,
	rovoActivationResource,
	calendarConnectorsResource,
];
homeTabRouteDefinition.query = [
	...WAC_CROSSFLOW_PARAMS.map((param) => `${param}?`),
	'src?',
	'cloudId?',
];
export const homeTabRoute: GlobalHomePageRoute = homeTabRouteDefinition;
